export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'name', sortable: true },
    { key: 'info', sortable: true },
    { key: 'admission_year', sortable: true },
    { key: 'is_active', sortable: true },
    { key: 'actions' },
  ]

  return {
    tableColumns,
  }
}
